export default "__VITE_ASSET__C6s9l1nG__"